<div class="header" *ngIf="type === 'page'">
	<div class="back-button" (click)="goBack()">
		<span class="freud-icon freud-icon-xs freud-icon-arrow-left"></span>
		{{ 'PROMPTUARY.GOBACK' | translate }}
	</div>

	<div class="headline">
		<div class="contact-name">{{ appointment?.userName }}</div>

		<div class="wrap-group">
			<div class="date">
				<span class="freud-icon freud-icon-sm freud-icon-calendar-event"></span>
				<div class="value">
					{{ appointment?.day | date: 'd MMM yy' }}
				</div>
			</div>

			<div class="hour">
				<span class="freud-icon freud-icon-sm freud-icon-clock"></span>
				<div class="value">{{ appointment?.day | date: "H'h'mm" }}</div>
			</div>
		</div>
	</div>

	<tabs-row
		[selectedTabIndex]="tabIndex"
		[tabList]="tabList"
		(changeTab)="changeTab($event)"
	></tabs-row>
</div>

<div
	[ngClass]="{ hidden: tabIndex !== 0 }"
	*ngIf="appointment && unifiedPromptuary.form"
>
	<div class="body" [ngClass]="{ 'body--sidebar': type === 'sidebar' }">
		<promptuary-no-show
			[appointment]="appointment"
			(changeNoshow)="updateNoshow($event)"
			[type]="type"
		></promptuary-no-show>

		<div class="body-form" *ngIf="!appointment.noShow">
			<promptuary-reasons
				type="page"
				*ngIf="appointment"
				[appointmentId]="appointment.id"
				[initialValue]="appointment.contactReason"
				[formField]="unifiedPromptuary.form.get('reasons')"
				(onSaving)="unifiedPromptuary.setAutoSaveLoading('reasons')"
				(onSaved)="unifiedPromptuary.autosaveComplete('reasons')"
			></promptuary-reasons>

			<div class="field">
				<div class="info-row">
					<status-icon
						[number]="2"
						[complete]="
							unifiedPromptuary.form.get('complaintAndDuration').valid
						"
					></status-icon>
					<div class="wrap-group">
						<div class="info">
							{{
								'PROMPTUARY.COMPLAINT_AND_DURATION'
									| translate: { name: firstName }
							}}*
						</div>
						<div class="subinfo">
							{{ 'PROMPTUARY.DESCRIPTION_BELOW' | translate }}
						</div>
					</div>
				</div>

				<div>
					<autosave-textarea
						[fetchInitialValue]="false"
						[formControl]="unifiedPromptuary.form.get('complaintAndDuration')"
						[initialValue]="
							unifiedPromptuary.form.get('complaintAndDuration').value
						"
						(valueSaving)="
							unifiedPromptuary.setAutoSaveLoading('complaintAndDuration')
						"
						(valueSaved)="
							unifiedPromptuary.autosaveComplete('complaintAndDuration')
						"
						[appointment]="autoSaveData"
						property="complaintAndDuration"
						service="autoSaveField"
					></autosave-textarea>
				</div>
			</div>

			<promptuary-service-evolution-crm
				step="3"
				[autoSaveData]="autoSaveData"
				[formGroup]="unifiedPromptuary.form"
			></promptuary-service-evolution-crm>

			<div class="field">
				<div class="info-row">
					<status-icon
						[number]="4"
						[complete]="unifiedPromptuary.form.get('psychicExamination').valid"
					></status-icon>
					<div class="wrap-group">
						<div class="info">
							{{ 'PROMPTUARY.PSYCHIC_EXAMINATION' | translate }}
						</div>
						<div class="subinfo">
							{{ 'PROMPTUARY.DESCRIPTION_BELOW' | translate }}
						</div>
					</div>
				</div>

				<autosave-textarea
					[fetchInitialValue]="false"
					[formControl]="unifiedPromptuary.form.get('psychicExamination')"
					[initialValue]="
						unifiedPromptuary.form.get('psychicExamination').value
					"
					(valueSaving)="
						unifiedPromptuary.setAutoSaveLoading('psychicExamination')
					"
					(valueSaved)="
						unifiedPromptuary.autosaveComplete('psychicExamination')
					"
					[appointment]="autoSaveData"
					property="psychicExamination"
					service="autoSaveField"
				></autosave-textarea>
			</div>
			<div class="field">
				<div class="info-row">
					<status-icon
						[number]="5"
						[complete]="unifiedPromptuary.form.get('clinicalExamination').valid"
					></status-icon>
					<div class="wrap-group">
						<div class="info">
							{{ 'PROMPTUARY.CLINICAL_EXAMINATION' | translate }}
						</div>
						<div class="subinfo">
							{{ 'PROMPTUARY.DESCRIPTION_BELOW' | translate }}
						</div>
					</div>
				</div>

				<autosave-textarea
					[fetchInitialValue]="false"
					[formControl]="unifiedPromptuary.form.get('clinicalExamination')"
					[initialValue]="
						unifiedPromptuary.form.get('clinicalExamination').value
					"
					(valueSaving)="
						unifiedPromptuary.setAutoSaveLoading('clinicalExamination')
					"
					(valueSaved)="
						unifiedPromptuary.autosaveComplete('clinicalExamination')
					"
					(valueChanged)="updateStep($event)"
					[appointment]="autoSaveData"
					property="clinicalExamination"
					service="autoSaveField"
				></autosave-textarea>
			</div>

			<div class="field">
				<div class="info-row zk-mb-5">
					<status-icon
						[number]="formSteps.ICD.number"
						[complete]="formSteps.ICD.complete"
					></status-icon>
					<div class="wrap-group">
						<div class="info">{{ 'PROMPTUARY.ICD' | translate }}*</div>
						<div class="subinfo">
							{{ 'PROMPTUARY.DESCRIPTION_BELOW' | translate }}
						</div>
					</div>
				</div>

				<cgi-search
					[value]="_icd"
					(onSelect)="addIcdValue($event)"
					(onRemove)="removeIcdValue($event)"
				>
				</cgi-search>
			</div>

			<promptuary-cgi
				[clientId]="appointment?.profileId"
				[appointmentId]="appointmentId"
				[mainType]="mainType"
				[stepStart]="7"
				property="CGI"
				service="form"
				[formArray]="unifiedPromptuary.form.get('cgi')"
				(onSaving)="unifiedPromptuary.setAutoSaveLoading('cgi')"
				(onSaved)="unifiedPromptuary.autosaveComplete('cgi')"
				(onRequired)="unifiedPromptuary.cgiOnRequired($event)"
			></promptuary-cgi>

			<div class="field">
				<div class="info-row">
					<status-icon
						[number]="8"
						[complete]="
							unifiedPromptuary.form.get('alarmSignals').valid &&
							unifiedPromptuary.form.get('alarmSignalsReason').valid
						"
					></status-icon>
					<div class="wrap-group">
						<div class="info">
							{{ 'PROMPTUARY.ALARM_SIGNALS' | translate }}*
						</div>
						<div class="subinfo">
							{{ 'PROMPTUARY.ALARM_SIGNALS_H2' | translate }}
						</div>
					</div>
				</div>

				<div class="radio-group">
					<freud-radio-button
						[(ngModel)]="unifiedPromptuary.form.get('alarmSignals').value"
						[radioValue]="false"
						[bgColor]="false"
						[label]="'Não'"
						[name]="'alarmSignals'"
						(valueChange)="setAlarmsSignals(false)"
					>
					</freud-radio-button>

					<freud-radio-button
						[(ngModel)]="unifiedPromptuary.form.get('alarmSignals').value"
						[radioValue]="true"
						[bgColor]="false"
						[label]="'Sim'"
						[name]="'alarmSignals'"
						(valueChange)="setAlarmsSignals(true)"
					>
					</freud-radio-button>
				</div>

				<div
					*ngIf="
						appointment && unifiedPromptuary.form.get('alarmSignals').value
					"
					class="alarm-details"
				>
					<div class="info">
						{{ 'PROMPTUARY.ALARM_DESCRIPTION' | translate }}
					</div>
					<autosave-textarea
						[fetchInitialValue]="false"
						[formControl]="unifiedPromptuary.form.get('alarmSignalsReason')"
						[initialValue]="
							unifiedPromptuary.form.get('alarmSignalsReason').value
						"
						(valueSaving)="
							unifiedPromptuary.setAutoSaveLoading('alarmSignalsReason')
						"
						(valueSaved)="
							unifiedPromptuary.autosaveComplete('alarmSignalsReason')
						"
						[appointment]="autoSaveData"
						property="alarmSignalsReason"
						service="autoSaveField"
					></autosave-textarea>
				</div>
			</div>

			<div class="field">
				<div class="info-row">
					<status-icon
						[number]="9"
						[complete]="unifiedPromptuary.form.get('conduct').valid"
					></status-icon>
					<div class="wrap-group">
						<div class="info">{{ 'PROMPTUARY.CONDUCT' | translate }}*</div>
						<div class="subinfo">
							{{ 'PROMPTUARY.CONDUCT_H2' | translate: { name: firstName } }}
						</div>
					</div>
				</div>

				<autosave-textarea
					[fetchInitialValue]="false"
					[formControl]="unifiedPromptuary.form.get('conduct')"
					[initialValue]="unifiedPromptuary.form.get('conduct').value"
					(valueSaving)="unifiedPromptuary.setAutoSaveLoading('conduct')"
					(valueSaved)="unifiedPromptuary.autosaveComplete('conduct')"
					[appointment]="autoSaveData"
					property="conduct"
					service="autoSaveField"
				></autosave-textarea>
			</div>
			<div class="field">
				<promptuary-outcome
					[formGroup]="unifiedPromptuary.form"
					[appointment]="appointment"
					[autoSaveData]="autoSaveData"
					[isAssistanceJourney]="isAssistanceJourney"
					(onChange)="setPromptuaryValue($event.field, $event.value)"
					(onSaving)="unifiedPromptuary.setAutoSaveLoading($event)"
					(onSaved)="unifiedPromptuary.autosaveComplete($event)"
				></promptuary-outcome>
			</div>

			<!-- <div class="field">
				<promptuary-task
					[formGroup]="unifiedPromptuary.form"
					[appointmentId]="appointmentId"
					[contactId]="appointment?.profileId"
					[professionalId]="appointment?.professionalId"
				>
				</promptuary-task>
			</div> -->

			<freud-button
				id="promptuary-form-page-button"
				*ngIf="type === 'page'"
				[disabled]="
					!stepsComplete || unifiedPromptuary.form.status === 'INVALID'
				"
				[loading]="
					unifiedPromptuary.autosaveLoading.length > 0 ||
					unifiedPromptuary.isRegistering
				"
				(click)="unifiedPromptuary.toggleRegisterModal(true)"
			>
				{{
					(unifiedPromptuary.autosaveLoading.length > 0
						? 'PROMPTUARY.SAVING_CHANGES'
						: 'PROMPTUARY.REGISTER'
					) | translate
				}}
			</freud-button>

			<div class="fixed-buttons" *ngIf="type === 'sidebar'">
				<promptuary-compliance-section
					type="crm"
					[from]="from"
					[mainType]="mainType"
				></promptuary-compliance-section>
				<div class="zk-flex zk-gap-2">
					<freud-button
						color="secondary"
						[loading]="
							unifiedPromptuary.autosaveLoading.length > 0 ||
							unifiedPromptuary.isRegistering
						"
						(click)="cancel.emit()"
					>
						{{ 'PROMPTUARY.CANCEL' | translate }}
					</freud-button>
					<freud-button
						[disabled]="
							!stepsComplete || unifiedPromptuary.form.status === 'INVALID'
						"
						[loading]="
							unifiedPromptuary.autosaveLoading.length > 0 ||
							unifiedPromptuary.isRegistering
						"
						(click)="
							stepsComplete && unifiedPromptuary.toggleRegisterModal(true)
						"
					>
						{{
							(unifiedPromptuary.autosaveLoading.length > 0
								? 'PROMPTUARY.SAVING_CHANGES'
								: 'PROMPTUARY.REGISTER'
							) | translate
						}}
					</freud-button>
				</div>
			</div>
		</div>
	</div>

	<div class="footer" [ngClass]="{ 'footer--sidebar': type === 'sidebar' }">
		<div class="title">
			{{ 'PROMPTUARY.DOCUMENTARY_REGISTER_TITLE' | translate }}
		</div>
		<div class="zk-flex zk-gap-2 zk-items-center">
			<span class="freud-icon freud-icon-shield-check"></span>
			<div
				class="subtitle"
				[innerHTML]="'PROMPTUARY.DOCUMENTARY_REGISTER_SUBTITLE' | translate"
			></div>
		</div>

		<autosave-textarea
			(valueSaving)="setLoading('session-note')"
			(valueChanged)="updateStep($event)"
			(valueSaved)="unifiedPromptuary.autosaveComplete('session-note')"
			[appointment]="autoSaveData"
			placeholder="{{ 'PROMPTUARY.PLACEHOLDERS.NOTES' | translate }}"
			property="session-note"
			service="saveDocumentaryRecord"
		></autosave-textarea>
	</div>
</div>

<memed-integration
	*ngIf="contact && tabIndex === 1"
	[contact]="contact"
	[visible]="tabIndex === 1"
	[appointmentId]="appointmentId"
	[clientId]="clientId"
	[memedElemScriptId]="memedElemScriptId"
	(back)="tabIndex = 0"
></memed-integration>

<promptuary-register-modal
	[showModal]="unifiedPromptuary.isRegisterModalOpen"
	[from]="from"
	[mainType]="mainType"
	[appointment]="appointment"
	[appointmentId]="appointmentId"
	[form]="unifiedPromptuary.form"
	promptuaryType="crm"
	(onRegistered)="emSavedPromptuary.emit($event)"
	[promptuary]="unifiedPromptuary?.form?.value"
>
</promptuary-register-modal>
